export interface SceneSettings {
  start: number;
  length: number;
}

// --------------------------------------------------------------
// Scenes positions
// --------------------------------------------------------------

const WALK_LENGTH = 1 / 5;
export const SCENE_LENGTH = (1 - WALK_LENGTH) / 7; // !!! Adjust to scene slots length if we decide to change them later !!!
export const SCENE_FADE_TIME = SCENE_LENGTH / 4;

export const SCENE_VISIBLE_TIME = SCENE_LENGTH - SCENE_FADE_TIME;
export const SCENE_HALF_VISIBLE_TIME = SCENE_VISIBLE_TIME * 0.5;

export const SCENE_0: SceneSettings = {
  start: 0,
  length: SCENE_LENGTH * 2,
};
export const SCENE_1: SceneSettings = {
  start: SCENE_0.start + SCENE_0.length,
  length: SCENE_LENGTH,
};
export const SCENE_2: SceneSettings = {
  start: SCENE_1.start + SCENE_1.length,
  length: SCENE_LENGTH,
};
export const SCENE_3: SceneSettings = {
  start: SCENE_2.start + SCENE_2.length,
  length: SCENE_LENGTH,
};
export const SCENE_4: SceneSettings = {
  start: SCENE_3.start + SCENE_3.length,
  length: SCENE_LENGTH,
};
export const SCENE_5: SceneSettings = {
  start: SCENE_4.start + SCENE_4.length,
  length: SCENE_LENGTH,
};
export const WALK_START = SCENE_5.start + SCENE_5.length;
export const WALK_END = 0.95;
